import styled from '@emotion/styled';

const StyledSpan = styled.span`
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 28px; /* 200% */
`;

const StyledDate = styled.div`
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px; /* 140% */
`;

const StyledSubTitle = styled.div`
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 142.857% */
`;

const Container = styled.div`
  margin-top: 12px;
  padding: 12px;
  background-color: var(--dk-bg-subtle, #f9fafb);
  border-radius: 16px;
`;

const StyledNoData = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: var(--dk-text-secondary, #888d96);
  font-size: 14px;
  font-weight: 400;
  line-height: 18px;
`;

export { StyledSpan, StyledDate, StyledSubTitle, Container, StyledNoData };
